(() => {
  const PIXEL = "1393629749550868";
  const queue = window.__nappiTrackQ || [];
  let state = "waiting";
  const send = ([name, params]) => {
    window.fbq("trackSingleCustom", PIXEL, name, params || {});
  };
  const flush = () => {
    while (queue.length) send(queue.shift());
  };
  const loadPixel = () => {
    if (state !== "waiting") return;
    state = "loading";
    if (!window.fbq) {
      const fbq = function() {
        if (fbq.callMethod) fbq.callMethod.apply(fbq, arguments);
        else fbq.queue.push(arguments);
      };
      window.fbq = fbq;
      if (!window._fbq) window._fbq = fbq;
      fbq.push = fbq;
      fbq.loaded = true;
      fbq.version = "2.0";
      fbq.queue = [];
      const script = document.createElement("script");
      script.async = true;
      script.src = "https://connect.facebook.net/en_US/fbevents.js";
      document.head.append(script);
    }
    window.fbq.disablePushState = true;
    window.fbq("set", "autoConfig", false, PIXEL);
    window.fbq("init", PIXEL);
    state = "ready";
    flush();
  };
  const allowed = () => {
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy || typeof privacy.marketingAllowed !== "function") return false;
    return privacy.marketingAllowed();
  };
  const decide = () => {
    if (allowed()) {
      const idle = window.requestIdleCallback || ((callback) => window.setTimeout(callback, 200));
      idle(loadPixel, { timeout: 3e3 });
    }
  };
  document.addEventListener("visitorConsentCollected", (event) => {
    if (event.detail?.marketingAllowed) decide();
  });
  const start = () => {
    if (window.Shopify?.customerPrivacy) {
      decide();
    } else if (typeof window.Shopify?.loadFeatures === "function") {
      window.Shopify.loadFeatures([{ name: "consent-tracking-api", version: "0.1" }], (error) => {
        if (!error) decide();
      });
    }
  };
  window.NappiTrack = (name, params) => {
    queue.push([name, params]);
    if (state === "ready") flush();
  };
  window.__nappiTrackQ = queue;
  if (document.readyState === "complete") start();
  else window.addEventListener("load", start, { once: true });
})();
